function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_53",
  "data-name": "Group 53",
  transform: "translate(8429.402 -7994.893)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_144",
  "data-name": "Path 144",
  d: "M-8358.82,8086.649h-3.528a3.533,3.533,0,0,0-3.529,3.529v3.529a3.532,3.532,0,0,0,3.529,3.529h3.528a3.532,3.532,0,0,0,3.529-3.529v-3.529A3.533,3.533,0,0,0-8358.82,8086.649Zm0,7.058h-3.528v-3.529h3.528Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_145",
  "data-name": "Path 145",
  d: "M-8344.7,8086.649h-3.529a3.533,3.533,0,0,0-3.528,3.529v3.529a3.532,3.532,0,0,0,3.528,3.529h3.529a3.532,3.532,0,0,0,3.529-3.529v-3.529A3.532,3.532,0,0,0-8344.7,8086.649Zm0,7.058h-3.529v-3.529h3.529Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_146",
  "data-name": "Path 146",
  d: "M-8330.587,8086.649h-3.529a3.532,3.532,0,0,0-3.528,3.529v3.529a3.531,3.531,0,0,0,3.528,3.529h3.529a3.532,3.532,0,0,0,3.529-3.529v-3.529A3.533,3.533,0,0,0-8330.587,8086.649Zm0,7.058h-3.529v-3.529h3.529Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_147",
  "data-name": "Path 147",
  d: "M-8358.82,8072.533h-3.528a3.533,3.533,0,0,0-3.529,3.529v3.529a3.533,3.533,0,0,0,3.529,3.529h3.528a3.533,3.533,0,0,0,3.529-3.529v-3.529A3.533,3.533,0,0,0-8358.82,8072.533Zm0,7.058h-3.528v-3.529h3.528Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_148",
  "data-name": "Path 148",
  d: "M-8344.7,8072.533h-3.529a3.533,3.533,0,0,0-3.528,3.529v3.529a3.533,3.533,0,0,0,3.528,3.529h3.529a3.532,3.532,0,0,0,3.529-3.529v-3.529A3.532,3.532,0,0,0-8344.7,8072.533Zm0,7.058h-3.529v-3.529h3.529Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_149",
  "data-name": "Path 149",
  d: "M-8330.587,8072.533h-3.529a3.531,3.531,0,0,0-3.528,3.529v3.529a3.532,3.532,0,0,0,3.528,3.529h3.529a3.533,3.533,0,0,0,3.529-3.529v-3.529A3.533,3.533,0,0,0-8330.587,8072.533Zm0,7.058h-3.529v-3.529h3.529Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_150",
  "data-name": "Path 150",
  d: "M-8358.82,8058.416h-3.528a3.533,3.533,0,0,0-3.529,3.53v3.529a3.533,3.533,0,0,0,3.529,3.529h3.528a3.533,3.533,0,0,0,3.529-3.529v-3.529A3.533,3.533,0,0,0-8358.82,8058.416Zm0,7.059h-3.528v-3.529h3.528Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_151",
  "data-name": "Path 151",
  d: "M-8344.7,8058.416h-3.529a3.533,3.533,0,0,0-3.528,3.53v3.529a3.533,3.533,0,0,0,3.528,3.529h3.529a3.532,3.532,0,0,0,3.529-3.529v-3.529A3.532,3.532,0,0,0-8344.7,8058.416Zm0,7.059h-3.529v-3.529h3.529Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_152",
  "data-name": "Path 152",
  d: "M-8330.587,8058.416h-3.529a3.532,3.532,0,0,0-3.528,3.53v3.529a3.531,3.531,0,0,0,3.528,3.529h3.529a3.533,3.533,0,0,0,3.529-3.529v-3.529A3.533,3.533,0,0,0-8330.587,8058.416Zm0,7.059h-3.529v-3.529h3.529Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_153",
  "data-name": "Path 153",
  d: "M-8328.823,8030.184h-22.938v-26.469a8.833,8.833,0,0,0-8.823-8.822h-59.994a8.833,8.833,0,0,0-8.823,8.822v30h14.116v44.113a8.833,8.833,0,0,0,8.823,8.823h33.527v8.823a8.832,8.832,0,0,0,8.821,8.823h35.291a8.833,8.833,0,0,0,8.823-8.823v-56.466A8.833,8.833,0,0,0-8328.823,8030.184Zm-86.463,0h-10.587v-26.469a5.3,5.3,0,0,1,5.294-5.293,5.3,5.3,0,0,1,5.293,5.293Zm15.835,52.936a8.731,8.731,0,0,0,1.812-5.294v-5.293h24.7v10.587Zm26.516-44.114v30h-28.233v8.822a5.3,5.3,0,0,1-5.294,5.294,5.3,5.3,0,0,1-5.294-5.294v-74.111a8.725,8.725,0,0,0-1.811-5.293h52.982a5.3,5.3,0,0,1,5.294,5.293v26.469h-8.823A8.832,8.832,0,0,0-8372.936,8039.006Zm49.406,56.466a5.3,5.3,0,0,1-5.294,5.294h-35.291a5.3,5.3,0,0,1-5.293-5.294v-56.466a5.3,5.3,0,0,1,5.293-5.293h35.291a5.3,5.3,0,0,1,5.294,5.293Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_154",
  "data-name": "Path 154",
  d: "M-8365.878,8054.887h38.82v-17.645h-38.82Zm3.529-14.116h31.762v10.587h-31.762Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_155",
  "data-name": "Path 155",
  d: "M-8383.524,8001.951h-1.764v19.41h19.41V8019.6A17.666,17.666,0,0,0-8383.524,8001.951Zm1.766,15.881v-12.243a14.151,14.151,0,0,1,12.242,12.243Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_156",
  "data-name": "Path 156",
  d: "M-8388.817,8009.009h-1.765a17.665,17.665,0,0,0-17.645,17.646,17.665,17.665,0,0,0,17.645,17.645,17.666,17.666,0,0,0,17.646-17.645v-1.765h-15.882Zm-3.529,3.639v13.276l-9.373,9.373a14.027,14.027,0,0,1-2.979-8.642A14.138,14.138,0,0,1-8392.347,8012.648Zm15.771,15.771a14.14,14.14,0,0,1-14.007,12.352,14.034,14.034,0,0,1-8.643-2.979l9.374-9.373Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_18",
  "data-name": "Rectangle 18",
  width: 3.529,
  height: 3.529,
  transform: "translate(-8362.35 8001.951)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_19",
  "data-name": "Rectangle 19",
  width: 3.529,
  height: 3.529,
  transform: "translate(-8362.35 8009.009)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_20",
  "data-name": "Rectangle 20",
  width: 3.529,
  height: 3.529,
  transform: "translate(-8362.35 8016.067)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_21",
  "data-name": "Rectangle 21",
  width: 31.762,
  height: 3.529,
  transform: "translate(-8408.228 8047.829)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_22",
  "data-name": "Rectangle 22",
  width: 31.762,
  height: 3.529,
  transform: "translate(-8408.228 8054.887)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_23",
  "data-name": "Rectangle 23",
  width: 3.529,
  height: 3.529,
  transform: "translate(-8379.995 8061.945)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_24",
  "data-name": "Rectangle 24",
  width: 3.529,
  height: 3.529,
  transform: "translate(-8387.053 8061.945)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_25",
  "data-name": "Rectangle 25",
  width: 3.529,
  height: 3.529,
  transform: "translate(-8394.111 8061.945)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_26",
  "data-name": "Rectangle 26",
  width: 10.587,
  height: 3.529,
  transform: "translate(-8408.228 8061.945)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_27",
  "data-name": "Rectangle 27",
  width: 3.529,
  height: 3.529,
  transform: "translate(-8422.344 8023.125)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_28",
  "data-name": "Rectangle 28",
  width: 3.529,
  height: 3.529,
  transform: "translate(-8422.344 8016.067)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_29",
  "data-name": "Rectangle 29",
  width: 3.529,
  height: 3.529,
  transform: "translate(-8422.344 8009.009)",
  fill: "#fff"
}));

var SvgSageIcon2 = function SvgSageIcon2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109.402,
    height: 109.402,
    viewBox: "0 0 109.402 109.402",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSageIcon2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sageIcon2.08ef2086.svg";
export { ForwardRef as ReactComponent };